import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import styles from "./CustomMenu.module.scss";

export default function CustomMenuScroll({ activeItem, menuRef }) {
  const [render, setRender] = useState(false);
  const [ready, setReady] = useState(false);
  const [dataItem, setDataItem] = useState({ left: 0, width: 0 });

  const rafId = useRef(0);
  const roRef = useRef(null);

  const measure = () => {
    cancelAnimationFrame(rafId.current);

    rafId.current = requestAnimationFrame(() => {
      const menuEl = menuRef?.current;
      const itemEl = activeItem; // DOM element (itemRef.current)
      if (!menuEl || !itemEl) return;

      const menuRect = menuEl.getBoundingClientRect();
      const itemRect = itemEl.getBoundingClientRect();

      // если меню скроллится по X — обязательно учитываем scrollLeft
      const scrollLeft = menuEl.scrollLeft || 0;

      const left = (itemRect.left - menuRect.left) + scrollLeft;
      const width = itemRect.width;

      setDataItem({ left, width });
      if (width > 0) setReady(true);
    });
  };

  useEffect(() => {
    setRender(true);
    return () => cancelAnimationFrame(rafId.current);
  }, []);

  useLayoutEffect(() => {
    if (!render) return;

    const menuEl = menuRef?.current;
    const itemEl = activeItem;

    measure();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => measure());
    }

    if (roRef.current) {
      roRef.current.disconnect();
      roRef.current = null;
    }

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => measure());
      if (menuEl) ro.observe(menuEl);
      if (itemEl) ro.observe(itemEl);
      roRef.current = ro;
    }

    const onScroll = () => measure();
    if (menuEl) menuEl.addEventListener("scroll", onScroll, { passive: true });

    const onResize = () => measure();
    window.addEventListener("resize", onResize, { passive: true });

    return () => {
      if (menuEl) menuEl.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      if (roRef.current) {
        roRef.current.disconnect();
        roRef.current = null;
      }
    };
  }, [render, activeItem, menuRef]);

  return (
    <div className={styles.customMenu__scroll}>
      {render && (
        <div
          className={styles.customMenu__scrollLine}
          style={{
            transform: `translate3d(${dataItem.left}px,0,0)`,
            width: `${dataItem.width}px`,
            opacity: ready ? 1 : 0
          }}
        />
      )}
    </div>
  );
}
